import { loadingService } from "@/utils/ui"
import html2Canvas from "html2canvas"
import { exportCrossTableExcel, exportExcel } from "@/views/Backend/Admin/Layout/mixin/export2Excel"
import exportChart from "@/views/Backend/Admin/Layout/mixin/ExportChart"

export default {
  mixins: [exportChart],
  computed: {
    exportOptions() {
      let result = []
      if (!this._.keys(this.figure).includes("canSeeAll") || this.figure.canSeeAll === null) {
        if (this.board.canExportImage) result.push({ command: "exportImage", title: "导出图片" })
        if (this.board.canExportExcel)
          result.push({
            command: "exportExcel",
            title: "导出数据"
          })
      } else {
        if (this.figure.canExportImage) result.push({ command: "exportImage", title: "导出图片" })
        if (this.figure.canExportExcel)
          result.push({
            command: "exportExcel",
            title: "导出数据"
          })
      }
      return result
    }
  },
  methods: {
    handleCommand(command) {
      switch (command) {
        case "exportImage":
          this.selectExportImage()
          break
        case "exportExcel":
          this.exportExcel()
          break
      }
    },
    selectExportImage() {
      let picInfo = ""
      if (!["cross-table", "indicator"].includes(this.figure.type)) {
        picInfo = this.$refs.image.getDataURL()
        this.exportImage(picInfo, this.figure.name)
      } else if (this.figure.type === "indicator") {
        let loadingInstance = loadingService()
        setTimeout(() => {
          html2Canvas(this.$el.querySelector("#image"))
            .then(canvas => {
              picInfo = canvas.toDataURL("image/png")
              this.exportImage(picInfo, this.figure.name)
            })
            .finally(() => loadingInstance.close())
        }, 100)
      } else {
        let loadingInstance = loadingService()
        setTimeout(() => {
          let ref = this.$refs.image.$refs.pivotTable
          ref.dealExportImage("before").then(() => {
            setTimeout(() => {
              let dom = this.$refs.image.$refs.pivotTable.$refs.xTable.$el
              html2Canvas(dom)
                .then(canvas => {
                  picInfo = canvas.toDataURL("image/png")
                  this.exportImage(picInfo, this.figure.name)
                })
                .finally(() => {
                  ref.dealExportImage("after").then(() => loadingInstance.close())
                })
            }, 200)
          })
        }, 100)
      }
    },
    exportExcel() {
      if (this.figure.type !== "cross-table") {
        require.ensure([], () => {
          let data = this.$refs.image?._data?.axisData || []
          let drillId = this.$refs.image?._data?.drillDownId
          let drillList = this.getDrillList(this.figure)
          let drill = drillList.find(drill => drill.id === drillId)
          let all = (drillId ? [drill] : this.figure.xAxisList).concat(this.figure.yAxisList)
          let allIds = all.map(axis => axis.id)
          let yIds = this.figure.yAxisList.map(yaxis => yaxis.id)
          const tHeader = all.map(axis => axis.name)
          let tableData = data.map(item => {
            let result = []
            allIds.forEach(id => {
              if (yIds.includes(id)) {
                result.push(Number(item[id]))
              } else {
                result.push(item[id])
              }
            })
            return result
          })
          exportExcel(tHeader, tableData, this.figure.name)
        })
      } else {
        let ref = this.$refs.image.$refs.pivotTable
        let loadingInstance = loadingService()
        ref.dealExportExcel("before").then(() => {
          setTimeout(() => {
            let data = this.$refs.image.$el
            exportCrossTableExcel(data, this.figure.name)
            setTimeout(() => {
              ref.dealExportExcel("after").then(() => loadingInstance.close())
            })
          })
        })
      }
    },
    getDrillList(figure) {
      let result = []
      figure.xAxisList.forEach(xAxis => {
        if (xAxis.drillDownList?.length) {
          result.push(...xAxis.drillDownList)
        }
      })
      return result
    },
    setChartDisabled() {
      if (
        [
          "basic-bar",
          "stacked-basic-bar",
          "bar",
          "stacked-bar",
          "line",
          "smoothed-line",
          "area-chart"
        ].includes(this.figure.type)
      ) {
        this.chartList.forEach(chart => {
          chart.disabled = ![
            "basic-bar",
            "stacked-basic-bar",
            "bar",
            "stacked-bar",
            "line",
            "smoothed-line",
            "area-chart"
          ].includes(chart.value)
        })
      } else if (["ring-diagram", "pie"].includes(this.figure.type)) {
        this.chartList.forEach(chart => {
          chart.disabled = !["ring-diagram", "pie"].includes(chart.value)
        })
      } else if (["indicator"].includes(this.figure.type)) {
        this.chartList.forEach(chart => {
          chart.disabled = !["indicator"].includes(chart.value)
        })
      } else if (["funnel"].includes(this.figure.type)) {
        this.chartList.forEach(chart => {
          if (!["funnel"].includes(chart.value)) chart.disabled = true
          else chart.disabled = false
        })
      } else if (["cross-table"].includes(this.figure.type)) {
        this.chartList.forEach(chart => {
          if (!["cross-table"].includes(chart.value)) chart.disabled = true
          else chart.disabled = false
        })
      } else if (["map"].includes(this.figure.type)) {
        this.chartList.forEach(chart => {
          if (!["map"].includes(chart.value)) chart.disabled = true
          else chart.disabled = false
        })
      }
    },
    refreshBoard() {
      if (["indicator", "cross-table"].includes(this.figure.type)) {
        this.$refs.image.init(this.figure)
      } else if (this.figure.type === "map") {
        let hashMap = this.$refs.image.hashMap
        let key = this._.max(Array.from(hashMap.keys()))
        this.$refs.image.initMap(key, hashMap.get(key))
      } else {
        let drawInfo = this.$refs.image.drawInfo
        let drawIndex = drawInfo.length - 1
        this.$refs.image.changeChart(drawInfo[drawIndex], drawIndex)
      }
    }
  }
}
